/**
 * Created by Jerker Nord on 2020-01-09.
 */
import {IPolyBetLineConfig, PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {IBetLineWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {BonusBunniesParsedGameData} from "../server/data/BonusBunniesParsedGameData";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {BonusBunniesBetlineEvent} from "./BonusBunniesBetlineEvent";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";

export class BonusBunniesBetline extends PolyBetLine {

    private _betlineData:IBetWinData[];
    private _winAmount:PIXI.BitmapText;
    private _winAmountShadow:PIXI.Sprite;
    private _x:number = 400;
    private _y:number[] = [340, 195, 485, 340, 340];

    constructor(index:number, numberPosition:number[], betLineData:number[], config:IPolyBetLineConfig) {
        super(index, numberPosition, betLineData, config);
        this.addMultiplierEventListeners();
        this._winAmountShadow = new PIXI.Sprite(GameResources.getTextures("Shadow")[0]);
        this._winAmount = new PIXI.BitmapText("0", {
            fontName : "winNumbers",
            fontSize : 40
        });
        this._winAmount.visible = false;
        this._winAmountShadow.visible = false;
        this._winAmount.x = BonusBunniesGameConfig.instance.REEL_AREA_WIDTH / 2;
        this._winAmount.y = this._y[index - 1] - this._winAmount.height / 2 + 3;
        this.addChild(this._winAmountShadow);
        this.addChild(this._winAmount);
        this.addFeatureEventListeners();
    }

    private addFeatureEventListeners():void {
        EventHandler.addEventListener(this, BonusBunniesBetlineEvent.SHOW_WIN_BET_LINE_WINS, (event:GameEvent) => this.onShowWinBetLineWin(event.params[0]));
    }

    private addMultiplierEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.parsedGameData(event.params[0]));
    }

    private parsedGameData(data:BonusBunniesParsedGameData):void {
        this._betlineData = data.betWins;
    }

    private onShowWinBetLineWin(index:number):void {
        if(index !== this.index) {
            return;
        }
        this.showWin(true);
    }

    protected showStatic():void {
        this.showWin(false);
    }

    protected draw(numberPosition:number[], betLineData:number[], config:IPolyBetLineConfig):void {

        let sprite:PIXI.Sprite = new PIXI.Sprite();
        sprite.anchor.set(0, 0);
        sprite.x = BonusBunniesGameConfig.instance.REEL_AREA_POS_X + 20;

        const symbolHeight:number = BonusBunniesGameConfig.instance.SYMBOL_HEIGHT,
            reelPosY:number = BonusBunniesGameConfig.instance.REEL_AREA_POS_Y,
            symbolBottomPadding:number = BonusBunniesGameConfig.instance.SYMBOL_BOTTOM_PADDING;

        switch(this.index) {
            case 1:
                sprite.texture = GameResources.getTextures("betline_" + this.index)[0];
                sprite.y = (reelPosY + (symbolHeight / 2) - 5);
                break;
            case 2:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 1))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 2 - 15;
                break;
            case 3:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 2))[0];
                sprite.y = (reelPosY + symbolHeight / 2) * 3 - 30;
                break;
            case 4:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 3))[0];
                sprite.y = (reelPosY + symbolHeight / 2) * 4 - 45;
                break;
            case 5:
                sprite.texture = GameResources.getTextures("betline_" + this.index)[0];
                sprite.y = (reelPosY + (symbolHeight / 2) - 5);
                break;
            case 6:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 1))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 2 - 15;
                break;
            case 7:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 2))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 3 - 30;
                break;
            case 8:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 3))[0];
                sprite.scale.y = -1;
                sprite.y = (reelPosY + (symbolHeight / 2)) * 2;
                break;
            case 9:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 4))[0];
                sprite.scale.y = -1;
                sprite.y = (reelPosY + (symbolHeight / 2)) * 3 - 15;
                break;
            case 10:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 5))[0];
                sprite.scale.y = -1;
                sprite.y = (reelPosY + (symbolHeight / 2)) * 4 - 30;
                break;
            case 11:
                sprite.texture = GameResources.getTextures("betline_" + this.index)[0];
                sprite.y = (reelPosY + (symbolHeight / 2) - 5);
                break;
            case 12:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 1))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 2 - 15;
                break;
            case 13:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 2))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 3 - 30;
                break;
            case 14:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 3))[0];
                sprite.scale.y = -1;
                sprite.y = (reelPosY + (symbolHeight / 2)) * 2;
                break;
            case 15:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 4))[0];
                sprite.scale.y = -1;
                sprite.y = (reelPosY + (symbolHeight / 2)) * 3 - 15;
                break;
            case 16:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 5))[0];
                sprite.scale.y = -1;
                sprite.y = (reelPosY + (symbolHeight / 2)) * 4 - 30;
                break;
            case 17:
                sprite.texture = GameResources.getTextures("betline_" + this.index)[0];
                sprite.y = (reelPosY + (symbolHeight / 2) - 5);
                break;
            case 18:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 1))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 2 - 15;
                break;
            case 19:
                sprite.texture = GameResources.getTextures("betline_" + 1)[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 1 - 15;
                sprite.rotation = 43 * PIXI.DEG_TO_RAD;
                sprite.scale.x = 1.2;
                sprite.x += 46;
                break;
            case 20:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 3))[0];
                sprite.scale.y = -1;
                sprite.y = (reelPosY + (symbolHeight / 2)) * 3 - 15;
                break;
            case 21:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 4))[0];
                sprite.scale.y = -1;
                sprite.y = (reelPosY + (symbolHeight / 2)) * 4 - 30;
                break;
            case 22:
                sprite.texture = GameResources.getTextures("betline_" + 1)[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 1 - 15;
                sprite.rotation = 137 * PIXI.DEG_TO_RAD;
                sprite.scale.x = 1.2;
                sprite.x += BonusBunniesGameConfig.instance.SYMBOL_WIDTH * 3 + (BonusBunniesGameConfig.instance.SYMBOL_WIDTH / 2) + 30;
                break;
            case 23:
                sprite.texture = GameResources.getTextures("betline_" + this.index)[0];
                sprite.y = (reelPosY + (symbolHeight / 2) - 5);
                break;
            case 24:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 1))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 2 - 15;
                break;
            case 25:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 2))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 3 - 30;
                break;
            case 26:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 3))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 2;
                sprite.scale.y = -1;
                break;
            case 27:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 4))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 3 - 15;
                sprite.scale.y = -1;
                break;
            case 28:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 5))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 4 - 30;
                sprite.scale.y = -1;
                break;
            case 29:
                sprite.texture = GameResources.getTextures("betline_" + this.index)[0];
                sprite.y = (reelPosY + (symbolHeight / 2) - 5);
                break;
            case 30:
                sprite.texture = GameResources.getTextures("betline_" + (this.index - 1))[0];
                sprite.y = (reelPosY + (symbolHeight / 2)) * 4 - 30;
                sprite.scale.y = -1;
                break;
            default:
                break;
        }
        this.addChild(sprite);
        StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.BET_LINES.name).addChild(this);
        this.alpha = 0;
    }

    protected showWin(withWinAmount:boolean = false):void {
        super.showWin();

        const id:number = this.index;
        this._winAmount.visible = false;
        this._winAmountShadow.visible = false;
        if(!withWinAmount) {
            return;
        }
        (<IBetLineWinData[]>this._betlineData).forEach((data:IBetLineWinData) => {
            if(data.betLineIndex === (id - 1)) {
                this._winAmount.visible = true;
                this._winAmount.text = (data.multipliedAmount.toFixed(2)).toString();
                this._winAmount.x = (Helper.getSymbolPositions(2, 1)[0] - this._winAmount.width / 2) - (BonusBunniesGameConfig.instance.SYMBOL_WIDTH / 2);
                this._winAmount.y = Helper.getSymbolPositions(2, data.betLine[2])[1] - (this._winAmount.height / 3);
                this._winAmountShadow.y = Helper.getSymbolPositions(2, data.betLine[2])[1];
                if(id == 5 || id == 6 || id == 7 || id == 20 || id == 21 || id == 22 || id == 30) {
                    this._winAmount.position.y += BonusBunniesGameConfig.instance.SYMBOL_HEIGHT / 2;
                    this._winAmountShadow.position.y += BonusBunniesGameConfig.instance.SYMBOL_HEIGHT / 2;
                }
                if(id == 8 || id == 9 || id == 10 || id == 17 || id == 18 || id == 19 || id == 29) {
                    this._winAmount.position.y -= BonusBunniesGameConfig.instance.SYMBOL_HEIGHT / 2;
                    this._winAmountShadow.position.y -= BonusBunniesGameConfig.instance.SYMBOL_HEIGHT / 2;
                }
                this._winAmountShadow.visible = true;
                this._winAmountShadow.alpha = 0.8;
                this._winAmountShadow.anchor.set(0.5);
                this._winAmountShadow.width = this._winAmount.width * 2;
                this._winAmountShadow.height = this._winAmount.height * 3;
                this._winAmountShadow.x = Helper.getSymbolPositions(2, 1)[0] - (BonusBunniesGameConfig.instance.SYMBOL_WIDTH / 2);
            }
        });
    }

    protected hideAll():void {
        EventHandler.dispatchEvent(new GameEvent("HIDE_SHINE"));
        super.hideAll();
    }
}